import { TripProfileTypeEnum } from './trip-profile-type-enum';

export class LegHistoryInfo {
  departureDate: Date = null;
  departureFboName: string = null;
  arrivalFboName: string = null;
  eft: number = null;
  originIcaoCode?: string;
  destinationIcaoCode?: string;
  toIsTechStop: boolean = null;
  pax: number = null;
  tripProfileType?: TripProfileTypeEnum = null;

  getDepartureFboName(): string {
    return this.departureFboName;
  }

  setDepartureFboName(fboName: string): LegHistoryInfo {
    this.departureFboName = fboName;
    return this;
  }

  getArrivalFboName(): string {
    return this.arrivalFboName;
  }

  setArrivalFboName(fboName: string): LegHistoryInfo {
    this.arrivalFboName = fboName;
    return this;
  }

  getDepartureDate(): Date {
    return this.departureDate;
  }

  setDepartureDate(departureDate: Date): LegHistoryInfo {
    this.departureDate = departureDate;
    return this;
  }

  getEft(): number {
    return this.eft;
  }

  setEft(eft: number): LegHistoryInfo {
    this.eft = eft;
    return this;
  }

  getTechStop(): boolean {
    return this.toIsTechStop;
  }

  setTechStop(value: boolean): LegHistoryInfo {
    this.toIsTechStop = value;
    return this;
  }

  getOriginIcaoCode(): string {
    return this.originIcaoCode;
  }

  setOriginIcaoCode(originIcaoCode: string): LegHistoryInfo {
    this.originIcaoCode = originIcaoCode;
    return this;
  }

  getDestinationIcaoCode(): string {
    return this.destinationIcaoCode;
  }

  setDestinationIcaoCode(destinationIcaoCode: string): LegHistoryInfo {
    this.destinationIcaoCode = destinationIcaoCode;
    return this;
  }

  getPax(): number {
    return this.pax;
  }

  setPax(pax: number): LegHistoryInfo {
    this.pax = pax;
    return this;
  }

  getTripProfileType(): TripProfileTypeEnum {
    return this.tripProfileType;
  }

  setTripProfileType(tripProfileType: TripProfileTypeEnum): LegHistoryInfo {
    this.tripProfileType = tripProfileType;
    return this;
  }
}
